/**
 * Calculates the area of a polygon given an array of coordinate points
 *
 * @param {number[][]} polygon - A simple number[][] defining the polygon
 * @returns {number} The area of the polygon
 *
 */
export function getSimpleArrayArea(polygon: number[][]) {
  if (polygon.length < 3) {
    return 0;
  }

  // Use Shoelace formula (coordinate area formula)
  let area = 0;
  for (let i = 0; i < polygon.length; i++) {
    const j = (i + 1) % polygon.length;
    area += polygon[i][0] * polygon[j][1];
    area -= polygon[j][0] * polygon[i][1];
  }

  // Take absolute value and divide by 2
  return Math.abs(area) / 2;
}
